import { AxiosResponse } from 'axios';
import { request } from './http-client';
import { TParams } from './types';

export interface ShipperCategoryResponse {
  count: string;
  shipper_categories: ShipperCategory[];
}

export type ILocales = 'uz' | 'ru' | 'en';

export interface IMultiLang {
  ru?: string;
  en?: string;
  uz?: string;
}

export interface ShipperCategory {
  id: string;
  created_at: string;
  updated_at: string;
  is_active: boolean;
  name: IMultiLang;
  shipper_ids: string[];
  shipper_datas: ShipperData[];
  image: string;
}

export interface ShipperData {
  shipper_id: string;
  shipper_name: string;
  shipper_logo?: string;
  shipper_menu_image?: string;
}

const shipperCategoryService = {
  getAll(params: TParams, shipper_id?: string, platform_id?: string) {
    return request.get<ShipperCategoryResponse>(`/v2/shipper-categories`, {
      params,
      headers: {
        Shipper: shipper_id,
        Platform: platform_id,
      },
    });
  },

  getById(
    id?: string,
    shipper_id?: string,
    platform_id?: string
  ): Promise<AxiosResponse<ShipperCategory>> {
    return request.get<ShipperCategory>(`/v2/shipper-categories/${id}`, {
      headers: {
        Shipper: shipper_id,
        Platform: platform_id,
      },
    });
  },
};

export default shipperCategoryService;
